// src/components/Contact.jsx
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaEnvelope, FaDownload, FaCopy, FaCheck } from 'react-icons/fa';
import './Contact.css';

const Contact = ({ t }) => {
  const [emailCopied, setEmailCopied] = useState(false);

  const socialLinks = [
    {
      icon: <FaGithub />,
      label: 'GitHub',
      url: 'https://github.com/Bat0oo',
      username: '@Bat0oo',
      color: 'blue'
    },
    {
      icon: <FaLinkedin />,
      label: 'LinkedIn',
      url: 'https://www.linkedin.com/in/miloradmaksic01/',
      username: 'miloradmaksic01',
      color: 'blue'
    },/*
    {
      icon: <FaInstagram />,
      label: 'Instagram',
      url: 'https://www.instagram.com/bat0oo/',
      username: '@bat0oo',
      color: 'pink'
      
    },*/
    {
      icon: <FaEnvelope />,
      label: 'Email',
      url: 'mailto:miloradmaksic01@gmail.com',
      username: 'Send Email',
      color: 'blue'
    }
  ];

  const handleCopyEmail = () => {
    navigator.clipboard.writeText('miloradmaksic01@gmail.com');
    setEmailCopied(true);
    setTimeout(() => setEmailCopied(false), 2000);
  };

  return (
    <section className="contact" id="contact">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title neon-text">{t.contact.title}</h2>
          <p className="contact-subtitle">{t.contact.subtitle}</p>

          <div className="contact-content">
            {/* Email Highlight */}
            <motion.div
              className="email-card neon-border"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.02, boxShadow: 'var(--glow-blue)' }}
            >
              <FaEnvelope className="email-icon" />
              <div className="email-details">
                <h3 className="email-label">{t.contact.email}</h3>
                <p className="email-address">miloradmaksic01@gmail.com</p>
              </div>
              <motion.button
                className="copy-btn neon-button"
                onClick={handleCopyEmail}
                whileTap={{ scale: 0.95 }}
              >
                {emailCopied ? (
                  <>
                    <FaCheck /> {t.contact.emailCopied}
                  </>
                ) : (
                  <>
                    <FaCopy /> {t.contact.copyEmail}
                  </>
                )}
              </motion.button>
            </motion.div>

            {/* Social Links Grid */}
            <div className="contact-socials">
              {socialLinks.map((link, index) => (
                <motion.a
                  key={index}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`contact-social-card neon-border-${link.color}`}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.3 + index * 0.1 }}
                  viewport={{ once: true }}
                  whileHover={{ 
                    scale: 1.05,
                    boxShadow: `var(--glow-${link.color})`
                  }}
                >
                  <div className={`social-icon-large social-icon-${link.color}`}>
                    {link.icon}
                  </div>
                  <div className="social-info">
                    <h4 className="social-label">{link.label}</h4>
                    <p className="social-username">{link.username}</p>
                  </div>
                </motion.a>
              ))}
            </div>

            {/* CV Download Button */}
            <motion.div
              className="cv-download-section"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.7 }}
              viewport={{ once: true }}
            >
              <a
                href="/cv.pdf"
                download="Milorad_Maksic_CV.pdf"
                className="cv-download-btn neon-button neon-button-large"
              >
                <FaDownload /> {t.contact.downloadCV}
              </a>
              <p className="cv-note">
                {/* INSTRUCTIONS: 
                    1. Add your CV PDF to the /public folder
                    2. Name it "cv.pdf" or update the href above
                    3. The file will be downloadable as "Milorad_Maksic_CV.pdf"
                */}
                📄 PDF Format • Updated 2025
              </p>
            </motion.div>
          </div>

          {/* Footer */}
          <motion.footer
            className="footer"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.9 }}
            viewport={{ once: true }}
          >
            <p className="footer-copyright">
              © 2025 Milorad Maksić 
            </p>
          </motion.footer>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
